import { GROUP_STATUS } from '@client/enums/group-status';

export const GROUP_FILTERS = {
  search: '',
  status: {
    active: {
      label: GROUP_STATUS.active.label.long,
      value: GROUP_STATUS.active.id,
      enabled: false
    },
    inactive: {
      label: GROUP_STATUS.inactive.label.long,
      value: GROUP_STATUS.inactive.id,
      enabled: false
    }
  },
  sorting: {
    key: 'status',
    dir: 'asc',
    options: {
      groupname: {
        label: 'label.NAME',
        value: 'groupname',
        enabled: false
      },
      status: {
        label: 'label.STATUS',
        value: 'status',
        enabled: true
      }
    }
  }
};
